export default "__VITE_ASSET__CpJSZ_yu__"